import * as React from 'react';
import { ThemeProvider, useTheme } from '@mui/material/styles';
import {darken, lighten, alpha} from "@mui/material";
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import FormLabel from '@mui/material/FormLabel';
import FormControl from '@mui/material/FormControl';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import { ErrorBoundary } from 'react-error-boundary'

import Chip from '@mui/material/Chip';
import Bs4Tooltip from '../../Bs4Components/Bs4Tooltip';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import CancelIcon from '@mui/icons-material/Cancel';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Link from '@mui/material/Link';

import Bs4PopperMenu from '../../Bs4Components/Bs4PopperMenu';
import Bs4MainDispatch from '../../Bs4MainDispatch';
import Bs4Kartoteka from '../../Bs4Kartoteka';
import Bs4Stores from '../../Bs4Stores';
import { EventEmit, isNullOrNaN, isObject, shallowEqual } from '../../Bs4Components/Bs4Utils'
import Bs4FormElement from '../Bs4FormElement';
import { getFieldTheme } from '../../Bs4Theme/Bs4Theme';
import Bs4I18N from '../../Bs4I18N';

import { useDroppable, useDraggable } from '@dnd-kit/core';

import { SmallScreenContext } from '../../Bs4Theme/Bs4UxTemplates';

export default class Bs4GenericField extends Bs4FormElement {
  static CHANGE = 'change';
  static CHANGE_STORE = 'change_store';
  static FOCUS_ENTER = 'focus_enter';
  static FOCUS_LEAVE = 'focus_leave';
  static CHANGE_SELF = 'change_self';
  static CHANGE_DIRTY = 'change_dirty';
  static CHANGE_SELECT = 'change_select';
  static CHANGE_OPTIONS_MULTIPLE = 'change_options_multiple';
  static CHANGE_OPTIONS_SINGLE = 'change_options_single';
  static CHANGE_FILE_MAXIMIZED = 'change_file_maximized';
  static SUMMARY_FIELD_CLICKED = 'summary_field_clicked';
  static OPEN_POPUP_VIEW = 'open_popup_view';
  static NO_ERROR = {error: false, helperText: ''};    
  static CLOSE_BS4_FORM = 'close_Bs4Form';

  initializeFormField() {
    let width = parseFloat(this.props.field.width);
    if (isNullOrNaN(width)) width = 50;
    if (width === 0) width = 'auto';
    else width = String(width + '%');
	  this.props.width = width;
    
    const bs4Kartoteka = Bs4Kartoteka.get(this.bs4KartotekaId)    
    if (this.props.field.bs4store) this.bs4Store = Bs4Stores.getBs4Store(this.props.field.bs4store) || [];    
    if (bs4Kartoteka) {
      this.bs4CardMainForObject = Boolean(bs4Kartoteka.getBs4CardMainForObject() === 'd');
      this.formFieldValue = (bs4Kartoteka.getFormFieldValue(this.optionId, this.inputId, this.props));
      this.setValueBs4(this.formFieldValue);
    }
    this.resetOriginalValue();
    this.readOnly = this.isParamSelected('READONLY');
    //this.readOnly = true;
    this.newLine = this.isParamSelected('NEWLINE');
    this.eventEmit = new EventEmit();
    if (this.props.field.wherePutLabel == 'n') this.props.field.hideLabel = true;
    this.filter_attrs_4 = Array.isArray(this.props?.field?.filter_attrs) && this.props.field.filter_attrs.includes('4');
    // this.filter_attrs_4 = this.filter_attrs_4 || Boolean(this.props?.field?.xtype === 'bs4Number');

    if (this.props.criterion && this.getValue()) {
      this.setSelected(true);
    }
    
    this.on(Bs4GenericField.FOCUS_ENTER, (field) => {        
      if (this.bs4Form) this.bs4Form.currentField = this;
    });

    this.on(Bs4GenericField.FOCUS_LEAVE, (field) => {        
      if (this.bs4Form && this.bs4Form.currentField === this) this.bs4Form.currentField = null;
    });

    if (this.isParamSelected('ATRYB_ONCHANGE')) {
			let valueOld = null;
			let valueNew = null;
      let focus_entered = false;
  
      
      if (this.atrybOnchange === Bs4GenericField.CHANGE_SELF) {        
        this.on(Bs4GenericField.CHANGE_SELF, (field) => {
          if (this.DEBYG_ATRYB_ONCHANGE) console.log(this.getLabelPlane()+' === === === ATRYB_ONCHANGE CHANGE_SELF', valueOld, ' -> ',  this.getValue());
          if (this.isDifferentValues(valueOld, this.getValue())) {
            this.bs4Form.atrybOnchange(this.props.field.formId, 'Bs4FormFieldChanged');
          }
        });
      }

      this.on(Bs4GenericField.FOCUS_ENTER, (field) => {        
        if (this.DEBYG_ATRYB_ONCHANGE) console.log(this.getLabelPlane()+' === === === ATRYB_ONCHANGE FOCUS_ENTER');
				valueOld = this.getValue();
				valueNew = valueOld
        focus_entered = true;
      });

      this.on(Bs4GenericField.CHANGE, (field, oldValue, newValue) => {
        if (this.atrybOnchange === Bs4GenericField.CHANGE_SELF) return;
        if (this.DEBYG_ATRYB_ONCHANGE) console.log(this.getLabelPlane()+' === === === ATRYB_ONCHANGE CHANGE');
        if (this.atrybOnchange === Bs4GenericField.CHANGE) {
          if (this.DEBYG_ATRYB_ONCHANGE) console.log(this.getLabelPlane()+' === === === ATRYB_ONCHANGE CHANGE >>> ', oldValue, ' -> ', newValue);
          this.bs4Form.atrybOnchange(this.props.field.formId, 'Bs4FormFieldChanged');
        }
        valueNew = this.getValue();
      });

      this.on(Bs4GenericField.FOCUS_LEAVE, (field) => {     
        if (this.atrybOnchange === Bs4GenericField.CHANGE_SELF) return;
        if (this.DEBYG_ATRYB_ONCHANGE) console.log(this.getLabelPlane()+' === === === ATRYB_ONCHANGE FOCUS_LEAVE', valueOld, ' -> ', valueNew, focus_entered);
        if (this.atrybOnchange === Bs4GenericField.FOCUS_LEAVE)
        if (focus_entered && this.isDifferentValues(valueOld, valueNew)) {
          if (this.DEBYG_ATRYB_ONCHANGE) console.log(this.getLabelPlane()+' === === === ATRYB_ONCHANGE FOCUS_LEAVE >>> ', valueOld, ' -> ', valueNew);
          this.bs4Form.atrybOnchange(this.props.field.formId, 'Bs4FormFieldChanged');
        }
        valueOld = valueNew;
        valueNew = null;
        focus_entered = false;
      });
		}
  }

  text_ChangeWidth = Bs4I18N.getTT('Change width %s to %s', null, 'Bs4GenericField');
  text_doNotBreakLine = Bs4I18N.getTT('Do not break line', null, 'Bs4GenericField');
  text_breakLine = Bs4I18N.getTT('Break line', null, 'Bs4GenericField');
  text_Add_new = Bs4I18N.getTT('Add new', null, 'Bs4GenericField');
  text_Move = Bs4I18N.getTT('Move', null, 'Bs4GenericField');
  text_Edit = Bs4I18N.getTT('Edit', null, 'Bs4GenericField');
  text_Error = Bs4I18N.getTT('Error', 'Błąd', 'Bs4GenericField');
  text_SelectAll = Bs4I18N.getTT('Zaznacz / Usuń zaznaczenie wierszy. Znaleziono: %s', 'Zaznacz / Usuń zaznaczenie wierszy. Znaleziono: %s', 'Bs4GenericField');
  text_EditList = Bs4I18N.getTT('Edytuj listę', 'Edytuj listę', 'Bs4GenericField');
  
  DEBYG_ATRYB_ONCHANGE = true;
  atrybOnchange = Bs4GenericField.FOCUS_LEAVE;

  // atrybOnchange = (valueOld, valueNew) => {
  //   if (this.isDifferentValues(valueOld, valueNew)) {
  //     if (this.DEBYG_ATRYB_ONCHANGE) console.log(this.getLabelPlane()+' === === === ATRYB_ONCHANGE DifferentValues >>> ', valueOld, ' -> ', valueNew);
  //     this.bs4Form.atrybOnchange(this.props.field.formId, 'Bs4FormFieldChanged');
	// 	}
  // }
  
  labelDebug = false;
  getLabelPlane = () => {
    const label = this.props?.field?.fieldLabel || '';
    if (!this.labelDebug) return label;
    else {
      if (this.props.criterion) return this.props?.field?.inputId+':'+label ;
      return this.props?.field?.formId+':'+label ;
    }
  }

  handleClickLabel = (event) => {
    Bs4MainDispatch.commandParser('Bs4FormFieldLabel', {currFormId: this.props.field.formId, inputId: this.props.field.inputId}, this.bs4KartotekaId);
  }

  Bs4LinkLabel = () => {
    const formField = this;
    const [label, setLabel] = React.useState(this.getLabelPlane());    
    if (formField.isParamSelected('LINKLABEL')) return <Link href='#' onClick={formField.handleClickLabel} dangerouslySetInnerHTML={{__html: label}}/>
    else return <Box component='span' dangerouslySetInnerHTML={{__html: label}}/>
  }    

  Bs4TooltipLabel = () => {
    const formField = this;    
    if (formField.props?.field?.tooltip) return (
      <Bs4Tooltip
        title={<div dangerouslySetInnerHTML={{__html: formField.props.field.tooltip}}/>}
        arrow 
        placement="top"
        //placement="bottom-start"
        describeChild
      >
        {/* <Box component='span'>
          <formField.Bs4LinkLabel/>
          &nbsp;
          <sup>
            <small><Box className="far fa-info-circle" component='i'></Box></small>
          </sup>
        </Box>         */}
        <Box component='span'>
          <formField.Bs4LinkLabel/>
          &nbsp;
          <Box className="far fa-info-circle" component='i'/>
        </Box>        
      </Bs4Tooltip>
    ); else return (
      <formField.Bs4LinkLabel/>
    );
  }
  
  Bs4Label = (props) => {
    const formField = this;   
    const [selected, setSelected] = React.useState(this.isSelected());
    const atrybClipboard = this.isParamSelected('ATRYB_CLIPBOARD');

    React.useEffect(() => {
      this.on(Bs4GenericField.CHANGE_SELECT, (field, selected) => {        
        setSelected(selected);
      });      
    }, []);
    
    const handleClickSelect = (event) => {
      event.stopPropagation();
      if (formField.readOnly) return;
      formField.setSelected(!formField.isSelected());
    }    

    const handleClickClear = (event) => {
      event.stopPropagation();
      if (formField.readOnly) return;
      formField.clear();        
    }

    const handleCopyToClipboard = (event) => {
      let value = this.getValue();
      if (isObject(value) || Array.isArray(value)) value = JSON.stringify(value);
      navigator.clipboard.writeText(value);
    }
        
    if (formField.props.field.hideLabel) return null;

    const sxIconButton = formField.isNativelyClearable() ? {display: 'none'} : {};
    const disabledColor = this.readOnly ? {color: 'disabled'} : {};

    return (
      <Stack direction="row" justifyContent="flex-start" alignItems="center" spacing={0} p={0}>        
        {formField.props.criterion && !formField.isEmpty() && 
          <IconButton onClick={handleClickSelect} size='small' edge='start' disabled={this.readOnly}>   
            <React.Fragment>
              <CheckCircleIcon fontSize='small' sx={selected ? null : {display: 'none'}} {...disabledColor}/>
              <RadioButtonUncheckedIcon fontSize='small' sx={!selected ? null : {display: 'none'}} {...disabledColor}/>
            </React.Fragment>         
          </IconButton>          
        }
        {!formField.props.criterion && formField.isDirty() && <i className="fa-solid fa-user-pen">&nbsp;</i>}        
        <formField.Bs4TooltipLabel/>
        {formField.props.criterion && !formField.isEmpty() && !formField.readOnly && 
          <IconButton onClick={handleClickClear} size='small' edge='end'>
            <CancelIcon fontSize='small'/>
          </IconButton>
        }        
        {atrybClipboard ?
          <IconButton onClick={handleCopyToClipboard} size='small'>
            <i className="fa-thin fa-copy"/>
          </IconButton>
        : null}        
      </Stack>
    )
  }

  isParamSelected (param) {
    return this.props?.field?.atr && this.props.field.atr.indexOf(param) >= 0;  
  }

  hesValue () {
    return !this.readOnly;
  }
    
  getValue () {    
    return this.value;
  }

  //setValueBs4 - konwersja danych pobranych z serwera (init data)
  setValueBs4 (value) {
    if (typeof value === 'undefined') value = null;
    this.setValue(value);
  }

  //getValueBs4 - konwersja danych wysyłanych do serwera
  getValueBs4 () {
    return this.getValue();    
  }

  value = null;
  
  setValue (value) {
    const oldValue = this.value;
    this.value = value;      
    this.trigger(Bs4GenericField.CHANGE, this, oldValue, this.value);
    this.trigger(Bs4GenericField.CHANGE_DIRTY, this, this.isDirty());
  }

  elementSetStore(store) {
    // console.log('...Field...ELEMENT_SET_STORE...', this.props.field.xtype, this.getLabelPlane(), store);
    this.bs4Store = Array.isArray(store) ? store.map(item => ({id: item[0], name: item[1]})) : [];
    this.trigger(Bs4GenericField.CHANGE_STORE, this.bs4Store);
  }

  getValueFromBs4Store = (value, bs4Store) => {
    if (!Array.isArray(bs4Store)) return null;
    if (value?.id) value = value.id;
    return bs4Store.find(item => item.id == value) || null;
  }

  getSomeValueFromBs4Store = (value, bs4Store) => {
    if (!Array.isArray(bs4Store)) return null;
    if (value?.id) value = value.id;
    return bs4Store.find(item => item.id == value) || bs4Store[0] || null;
  }

  resetOriginalValue() {
    this.originalValue = this.getValue();
    this.trigger(Bs4GenericField.CHANGE_DIRTY, this, this.isDirty());
  }

  changesSaved() {
    this.resetOriginalValue();
  }

  isDifferentValues (oldValue, newVaue) {
    return oldValue != newVaue;
  }

  isDirty () {    
    if (!this.hesValue()) return false;    
    return this.isDifferentValues(this.originalValue, this.getValue());
  }

  clear() {
    if (this.readOnly) return;
    this.setValueBs4(null);
    this.setSelected(false)
  }

  isEmpty () {
    const value = this.getValue();
    if (!value) return true;
    if (Array.isArray(value) && value.length === 0) return true;
    try {
      if (value.size === 0) return true;
    } catch(error) {}
    // 2024-04-09
    // 60142 – Nie działają filtry typu bs4Date [Core]
    // try {
    //   if (Object.keys(value).length === 0) return true;
    // } catch(error) {}

    return false;
  }
    
  //Funkcja clear nie zostanie dodana jeżeli field już ją obsługuje.
  isNativelyClearable () {
    return false;
  }

  on(name, onFunction) {
    this.eventEmit.on(name, onFunction);
  }

off(onFunction) {
    this.eventEmit.off(onFunction);
  }

  trigger(name, ...params) {
    this.eventEmit?.trigger(name, ...params)    
  }

  selected = false;

  isSelected = () => {
    return this.selected && !this.isEmpty();
  }

	setSelected = (selected) => {
    this.selected = selected;
    this.trigger(Bs4GenericField.CHANGE_SELECT, this, this.isSelected());
  }

  summaryFieldClicked = () => {
    console.log('== Error === summaryFieldClicked == not implemented')
  }
  
  reloadGridCriteria = () => {
    const bs4Kartoteka = Bs4Kartoteka.get(this.bs4KartotekaId);
    const bs4Option = bs4Kartoteka.getBs4Option(this.optionId);
    bs4Option?.bs4Grid?.reload();
  }

  ViewSummaryDetails = (props) => {
    return null;
  }

  ViewChip = (props) => {
    const formField = this;
    const [selected, setSelected] = React.useState(this.isSelected());
    const [shortValue , setShortValue] = React.useState(this.getShortValue());    
    
    React.useEffect(() => {
      this.on(Bs4GenericField.CHANGE_SELECT, (field, selected) => {
        setSelected(selected);
      });

      this.on(Bs4GenericField.CHANGE, (field, oldValue, newValue) => {
        if (!formField.bs4Form.isOpenCriteria) setShortValue(this.getShortValue());
      })            
    }, []);

    
    const handleClickSelect = (event) => {
      event.stopPropagation();
      if (this.readOnly) return;
      this.setSelected(!this.isSelected())
      if (this.filter_attrs_4) this.reloadGridCriteria();
    }

    const handleClick = (event) => {
      event.stopPropagation();
      if (this.filter_attrs_4) handleClickSelect(event);
      else this.summaryFieldClicked(this.refFocus);
    }

    const handleDelete = (event) => {
      event.stopPropagation();
      this.clear();
      this.reloadGridCriteria();
    }
    
    const label = (      
      <React.Fragment>
        <span>{this.props.field.fieldLabel}:</span>
        {!formField.filter_attrs_4 && <span style={{color: '#000000', fontWeight: 'bold'}}>{shortValue}</span>}
      </React.Fragment>
    )

    const displayChip = selected || this.filter_attrs_4 ? null : {display: 'none'};
    const disabledColor = this.readOnly ? {color: 'disabled'} : {};    

    return (
      <React.Fragment>
      <Chip 
        size="small" 
        label={label} 
        onClick={handleClick}
        icon={selected ? <CheckCircleIcon onClick={handleClickSelect} {...disabledColor}/> : <RadioButtonUncheckedIcon onClick={handleClickSelect} {...disabledColor}/>}
        disabled={formField.isEmpty()}
        onDelete={formField.readOnly ? null : handleDelete}       
        variant={this.isSelected() ? 'filled' : 'outlined'}
        sx={{
          ...displayChip,
          '& .MuiChip-icon': {
            color: 'rgba(0, 0, 0, 0.26)', 
            fontSize: '16px', 
            cursor: 'pointer', 
            fill: 'currentColor',
          }
        }}
      />      
      {formField.filter_attrs_4 && <formField.ViewSummaryDetails/>}
      </React.Fragment>
    )
  }

  //Kryteria
  canCloseCriteria = true;

  getShortValue() {
    const value = String(this.getValue());
    if (value && value.length > 20) {
      return value.substring(0, 17)+'...';
    }
    return value;
  }

  notValidElementDom = (text) => {
    console.log('== Error === notValidElementDom not implemented ===');
  }

  setFocus = () => {console.log('=== Error === setFocus not implementef for', this.props.field.xtype)}
  
  ErrorBoundaryBs4 = (props) => {
    const formField = this;
    const [explode, setExplode] = React.useState(true)
    // const [color, setColor] = React.useState('transparent')
    // const [border, setBorder] = React.useState('none')
    const [error, setError] = React.useState(null)
    const theme = useTheme();

    // if (error) {
    //   console.log('===ErrorBoundaryBs4=== Error', error);
    //   console.log('===ErrorBoundaryBs4=== et', formField.props.field);      
    // }

    return (
      <ErrorBoundary
        FallbackComponent={(props) => props.resetErrorBoundary(props.error)}
        onReset={(error) => {
          setError(error)          
          //setColor('#ffa0a0')
          //setBorder('5px dashed red')
          setExplode(false)
        }}
        resetKeys={[explode]}
      >
        {explode 
        ? 
          props.children
        : 
          <FormControl fullWidth>
            {!this.props.field.hideLabel ? <FormLabel><formField.Bs4Label/></FormLabel> : null}
            <Typography sx={{color: theme.palette.error.main}}>{'Nie można wyświetlić elementu. Proszę sprawdzić konfigurację.'}</Typography>
          </FormControl>   
          // <Box backgroundColor={color} border={'5px dashed red'}>
          //   {/* <Typography variant="h5">{formField.text_Error}: {formField.props.field.xtype}</Typography>
          //   <div> </div>
          //   <div>{JSON.stringify(formField.props.field)}</div>
          //   <div> </div>
          //   <div>{error.message}</div> */}
          // </Box>          
        }
      </ErrorBoundary>
    )
  }

  ConstructorModeMenu = (props) => {
    const formField = this;    
    const width = parseFloat(formField.props.width);
    const changewidthmsg = React.useMemo(() => {
      let text = this.text_ChangeWidth;
      text = text.replace('%s', formField.props.width);        
      text = text.replace('%s', width === 100 ? '50%' : '100%');
      return text
      //width === 100 ? 'Change width '+formField.props.width+' to 50%' : 'Change width '+formField.props.width+' to 100%';
    }, [width, formField.props.width]);

    const changewidthico = width === 100 ? <i className="fa-solid fa-arrows-to-line fa-rotate-90"></i> : <i className="fa-solid fa-arrows-from-line fa-rotate-90"></i>;    

    const newlinemsg = this.newLine ? this.text_doNotBreakLine : this.text_breakLine;
    const newlineico = this.newLine ? <i className="fa-solid fa-arrow-turn-up"></i> : <i className="fa-solid fa-arrow-turn-down"></i>;

    const handleEdit = () => {
      const details = formField.props.criterion
      ? {currFormId: formField.props.field.formId, targetObject: formField.props.field.inputId.replace('kx', ''), targetOption: 467}
      : {currFormId: formField.props.field.formId, targetObject: formField.props.field.formId, targetOption: 298}; 
      Bs4MainDispatch.commandParser('Bs4OpenCard', details, this.bs4KartotekaId);
      props.closeMenu()
    }

    const handleWidth = () => {
      Bs4MainDispatch.commandParser('Bs4FormElemResize', {currFormId: formField.props.field.formId }, this.bs4KartotekaId);        
      props.closeMenu()
    }

    const handleNewLine = () => {       
      Bs4MainDispatch.commandParser('Bs4FormElemNewLine', {currFormId: formField.props.field.formId }, this.bs4KartotekaId);        
      props.closeMenu()
    }

    const handleMenuClose = () => {            
      props.closeMenu();
    }

    const handleClickXtype = (e) => {
      console.log('...xtype...', this.getLabelPlane(), this.props.field, this.getValue())
      if (this.formFieldValue) console.log('...formFieldValue.', this.formFieldValue)
      if (this.bs4Store) console.log('...xtype.Store.', this.bs4Store)      
    }
    
    return (
    <Bs4PopperMenu anchorEl={props.anchorEl} open={Boolean(props.anchorEl)} onClose={handleMenuClose}>
      <MenuItem>
        <Typography variant='h6' onClick={handleClickXtype}>{formField.props.field.xtype}</Typography>        
      </MenuItem>
      <MenuItem onClick={handleEdit}>
        <ListItemIcon><i className="fas fa-cog"></i></ListItemIcon>
        <ListItemText>{formField.text_Edit}</ListItemText>
      </MenuItem>
      {!formField.props.criterion ?
      <MenuItem onClick={handleWidth}>
        <ListItemIcon>{changewidthico}</ListItemIcon>
        <ListItemText>{changewidthmsg}</ListItemText>
      </MenuItem> : null}
      {!formField.props.criterion ?
      <MenuItem onClick={handleNewLine}>
        <ListItemIcon>{newlineico}</ListItemIcon>
        <ListItemText>{newlinemsg}</ListItemText>
      </MenuItem> : null}
    </Bs4PopperMenu>
    )
  }

  ViewConstructorMode = (props) => {
    if (!this.props.bs4ConstructorMode.enabled) return null;

    const formField = this;
    const [anchorElMenu, setAnchorElMenu] = React.useState(null);
    const [select, setSelect] = React.useState(false);

    const {activeCurrent} = React.useContext(this.bs4Form.activeCurrentContext);
    
    const handleGearMenu = (event) => {      
      setAnchorElMenu(event.currentTarget);
    }    

    const closeMenu = () => {            
      setAnchorElMenu(null);
      setSelect(false);
    }

    const handleSelect = (e) => {
      setSelect(e.type === 'mouseenter' || Boolean(anchorElMenu))
    }

    const showGear = props.showGear || Boolean(anchorElMenu);

    const sxGrill = React.useMemo(() => {
      let gril = this.getGrilleBox(activeCurrent?.formElement === this ? 2 : 1);
      // const display = (select || activeCurrent?.formElement === this || (activeCurrent?.formElement?.formElementType === this.formElementType))
      const display = (select || (activeCurrent?.type != 'file' && activeCurrent?.formElement?.formElementType === this.formElementType));

      return {
        display: display ? 'block' : 'none',
        ...gril
      }      

    }, [activeCurrent, select])
    
    return (
      <React.Fragment>
        <Box sx={{position:'absolute', top:0, right:0, bottom: 0, left: 0, ...sxGrill}}/>
        <IconButton 
          ref={props.setActivatorNodeRef}
          {...props.listeners}
          tabIndex={-1}          
          sx={{position:'absolute', top: -5, left:'60%', display: showGear ? 'block' : 'none', touchAction: 'none'}} 
          onMouseEnter={handleSelect}
          onMouseLeave={handleSelect}
        >
          <i className="fa-solid fa-arrows-up-down-left-right"></i>
        </IconButton>
        <IconButton 
          tabIndex={-1}
          sx={{position:'absolute', top: -5, right: -5, display: showGear ? 'block' : 'none'}} 
          onClick={handleGearMenu}
          onMouseEnter={handleSelect}
          onMouseLeave={handleSelect}          
        >
          <i className="fa-solid fa-gear"></i>
        </IconButton>
        <formField.ConstructorModeMenu anchorEl={anchorElMenu} closeMenu={closeMenu}/>
      </React.Fragment>
    )
  }

  getFieldDialogId = () => this.getElementId('_field_dialog');

  focus = false;

  handleFocusInOut = (event) => {
    //console.log('....focus....', event.type, event);

    let newFocus = event.type === 'focusin' || event.type === 'focus';
    if (event.type === 'focusout' || event.type === 'blur') {
      newFocus = Boolean(this.getParentNodeById(this.getElementId(), event.relatedTarget) || this.getParentNodeById(this.getFieldDialogId(), event.relatedTarget));
    }
          
    if (this.focus != newFocus) {
      this.trigger(newFocus ? Bs4GenericField.FOCUS_ENTER : Bs4GenericField.FOCUS_LEAVE, this);
      this.focus = newFocus;
    }
  }

  formElementType = 1;

  ViewComponent = (props) => {
    const formField = this;        

    const { setNodeRef: setNodeRefDroppable } = useDroppable({
      id: formField.getElementId('Droppable'),
      disabled: !this.props.bs4ConstructorMode.enabled,
      data: {
        formElement: this,
        type: 'form',
      }
    });  

    const { listeners, setNodeRef: setNodeRefDraggable, setActivatorNodeRef} = useDraggable({
      id: formField.getElementId('Draggable'),
      disabled: !this.props.bs4ConstructorMode.enabled,
      data: {
        formElement: this,
        type: 'form',
      },
    });

    return (
      <formField.ViewComponentDne 
        {...props} 
        setNodeRefDroppable={setNodeRefDroppable} 
        setNodeRefDraggable={setNodeRefDraggable}
        setActivatorNodeRef={setActivatorNodeRef} 
        listeners={listeners} 
      />
    )
  }

  ViewComponentDne = (props) => {
    const formField = this;    
    const [display, setDisplay] = React.useState(this.displayElementDom)
    const [dirty, setDirty] = React.useState(formField.isDirty());
    const [selectedCriterion, setSelectedCriterion] = React.useState(formField.isSelected);
    const [showGear, setShowGear] = React.useState(false);    
    const mainTheme = useTheme();
    const theme = React.useMemo(() => getFieldTheme(mainTheme, this.props.field.bs4style), [mainTheme])
    const refFocusInOut = React.useRef(null);
    const refShowTooltip = React.useRef(null);
    const smallScreen = React.useContext(SmallScreenContext);
    
    this.removeElementDom = () => {
      this.displayElementDom = 'none'
      setDisplay(this.displayElementDom);
    }

    formField.showElementDom = () => {
      this.displayElementDom = 'block'
      setDisplay(this.displayElementDom);
    }   
    
    const handleShowGear = React.useCallback((e) => {
      if (!this.props.bs4ConstructorMode.enabled) return null;
      setShowGear(e.type === 'mouseenter');
    }, [setShowGear]);

    React.useEffect(() => {
      if (this.isEqualId(props.showTooltip?.id)) {
        const close = (clase) => {
          props.showTooltip?.setShowTooltip(null);
          // if (this.bs4Form.closeCriteria) this.bs4Form.closeCriteria(null);
        }
  
        props.showTooltip?.showTooltip(refShowTooltip, close);
      }
  
      return () => {        
        if (this.isEqualId(props.showTooltip?.id)) {
          // console.log('...?????...', props)
        }
      }
    }, [props.showTooltip, refShowTooltip.current]);

    React.useEffect(() => {               
      this.getFormElementSize = () => {
        if (props.size) return props.size;
        if (refFocusInOut.current) {
          const rect = refFocusInOut.current.getBoundingClientRect();
          return {
            width: rect.width,
            height: rect.height,
          }
        }
      }

      this.on(Bs4GenericField.CHANGE_DIRTY, (field, fieldDirty) => {
        setDirty(fieldDirty);
      })

      if (formField.props.criterion) {
        formField.on(Bs4GenericField.CHANGE, (field, oldValue, newValue) => {
          field.setSelected(!field.isEmpty())
        })
      
        formField.on(Bs4GenericField.CHANGE_SELECT, (field, selected) => {
          setSelectedCriterion(selected);
        })
      }

      refFocusInOut.current.addEventListener("focusin", (e) => this.handleFocusInOut(e));
      refFocusInOut.current.addEventListener("focusout", (e) => this.handleFocusInOut(e));
    }, [refFocusInOut]);    

    const handleKeyDown = React.useCallback((event) => {      
      if (event.key === 'Enter' && this.bs4Form.closeCriteria && this.canCloseCriteria) {
        this.bs4Form.closeCriteria(event);
      }
    }, []);

    const sxSelected = selectedCriterion ? {
      backgroundColor: darken(theme.Bs4.backgroundColor, 0.05),
      borderColor: darken(theme.Bs4.backgroundColor, 0.1),
      borderWidth: '1px',
    } : {}
    
    const height = props.size ? props.size.height : formField.props.bs4flexframe && formField.bs4flexframeHeight ? '100%' : 'auto';
    const width = props.size ? props.size.width : formField.props.width;
    const flexGrow = smallScreen ? {flexGrow: 1} : {};

    const refSpeedTest = React.useRef({
      shallowEqualValues: null,
      shallowEqualProps: null,
    });    

    Bs4MainDispatch.speedRun((tag) => {
      const newObj = {  
        display,
        dirty,
        selectedCriterion,
        showGear,
        theme,            
      };
      console.log(Bs4MainDispatch.speedNextTime(tag), Bs4MainDispatch.speedBs4KarOpt(this.bs4KartotekaId, this.optionId), shallowEqual(newObj, refSpeedTest.current.shallowEqualValues, Bs4MainDispatch.speedPrefix+tag+' EqualValues'), shallowEqual(props, refSpeedTest.current.shallowEqualProps, Bs4MainDispatch.speedPrefix+tag+' EqualProps'));
      refSpeedTest.current.shallowEqualValues = newObj;
      refSpeedTest.current.shallowEqualProps = props;
    }, '..GField..');

    return (
      <ThemeProvider theme={theme}>
        <Box           
          id={formField.getElementId()}
          ref={node => {
            refFocusInOut.current = node;
            props.setNodeRefDraggable(node);
            props.setNodeRefDroppable(node);
          }} 
          // {...attributes}
          sx={{
            position: 'relative', 
            height: height, 
            width: width, 
            p: 0.0, 
            display: display,
            ...flexGrow,
          }}
          onMouseEnter={handleShowGear}
          onMouseLeave={handleShowGear}
          onKeyDown={handleKeyDown}
        >
          <Box
            ref={refShowTooltip}
            sx={{              
              position: 'relative', 
              height:'100%', 
              p: 1,               
              overflow: 'hidden',
              border: 'solid',
              backgroundColor: formField.props.field.xtype === 'bs4Button' ? 'transparent' : formField.props.field?.bs4style ? theme.palette.background.paper : 'transparent',
              borderColor: 'transparent',
              borderWidth: '1px',
              borderRadius: theme.shape.borderRadius+'px',
              ...(props.overlay ? {opacity: 0.3} : {}),
              ...sxSelected,
            }}
          >
            <formField.ErrorBoundaryBs4>            
              <formField.ViewComponentMemo/>
            </formField.ErrorBoundaryBs4>            
          </Box>
          <formField.ViewConstructorMode 
            showGear={showGear} 
            setActivatorNodeRef={props.setActivatorNodeRef}
            listeners={props.listeners}
          />
        </Box>
      </ThemeProvider>
    )
  }
  
  ViewComponentMemo = React.memo(() => {
    const formField = this;
    // return <Typography>{this.getLabelPlane()}</Typography>
    Bs4MainDispatch.speedRun((tag) => {
      console.log(Bs4MainDispatch.speedNextTime(tag), Bs4MainDispatch.speedBs4KarOpt(this.bs4KartotekaId, this.optionId), this.formId, this.props.field.xtype);
    }, '..GField..memo');
    return <formField.ViewComponentField fullWidth/>
  });

  ViewComponentField = (props) => {
    const formField = this;
    return <Typography>{this.getLabelPlane()}</Typography>
  }
}